<wbo-edit-grid [data]="model.data[fieldName]" [editable]="true" [removable]="true" [entityPath]="fieldName" [title]="'wbo.report.membership-type-selection.title'">
    <wbo-text-column field="name" [title]="'wbo.report.membership-type-selection.column.name'"></wbo-text-column>
    <wbo-text-column field="description" [title]="'wbo.report.membership-type-selection.column.description'"></wbo-text-column>
    <wbo-edit-grid-add-row [customAdd]="true">
        <wbo-edit-grid-add-row-quick-add (onSelect)="addFromMembershipType([$event])">
            <wbo-membership-type-single-select-edit-control></wbo-membership-type-single-select-edit-control>
        </wbo-edit-grid-add-row-quick-add>
        <wbo-edit-grid-add-row-actions>
            <wbo-edit-grid-add-row-search [searchComponent]="MembershipTypeSearchPageComponent" (onSelect)="addFromMembershipType($event)"></wbo-edit-grid-add-row-search>
        </wbo-edit-grid-add-row-actions>
    </wbo-edit-grid-add-row>
</wbo-edit-grid>
